import React from 'react';
import { Badge } from 'react-bootstrap';
import DataTable from '../common/DataTable';

const ProjectList = ({ projects, users, onEdit }) => {
  const headers = [
    { label: 'Company Name' },
    { label: 'Members' },
    { label: 'Action', align: 'right', width: '80px' }
  ];

  return (
    <DataTable 
      headers={headers}
      data={projects}
      emptyMessage="No companies created yet."
      renderRow={(p) => (
        <tr key={p._id}>
          <td className="align-middle">
            <strong>{p.name}</strong><br/>
            <small className="text-muted">{p.description}</small>
          </td>
          <td className="align-middle">
            {p.members.map(m => {
              const mUser = users.find(u => u._id === m.user);
              return (
                <div key={m.user} className="mb-1">
                  <Badge variant="light" className="border mr-2">
                    {mUser ? mUser.name : 'Admin/Owner'}
                  </Badge>
                  <Badge variant={m.role === 'editor' ? 'info' : 'secondary'}>
                    {m.role}
                  </Badge>
                </div>
              );
            })}
          </td>
          <td className="align-middle text-right">
            <button onClick={() => onEdit && onEdit(p)} className="btn btn-link btn-sm text-primary p-0" title="Edit Company Name">
              <i className="fas fa-edit"></i>
            </button>
          </td>
        </tr>
      )}
    />
  );
};

export default ProjectList;
